import SEO from '../../components/SEO';
import React, { useState } from 'react';
import Navigation from '../../components/Navigation';
import Footer from '../../components/Footer';
import AppointmentModal from '../../components/AppointmentModal';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const JuvenileJusticePage = () => {
  const [showAppointmentModal, setShowAppointmentModal] = useState(false);
  const [insuranceProviders, setInsuranceProviders] = useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const insuranceRes = await axios.get(`${API}/insurance`);
        setInsuranceProviders(insuranceRes.data);
      } catch (error) {
        // Error handled silently
      }
    };
    fetchData();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <SEO title="Youth Mental Health Services" description="Mental health and behavioral health services for justice-involved youth in Maryland. Therapy, rehabilitation, and case management at SDORA Wellbeing, Pikesville, MD." path="/services/juvenile-justice" />
      
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-indigo-600 to-blue-600 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            Juvenile Justice
          </h1>
          <p className="text-xl md:text-2xl text-indigo-100 max-w-3xl">
            Supporting youth involved in the legal system toward positive change, rehabilitation, and successful reintegration.
          </p>
        </div>
      </div>

      {/* Service Description */}
      <div className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">What is Juvenile Justice Support?</h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Juvenile Justice provides specialized support for youth involved in the legal system through targeted interventions and guidance. We address behavioral and mental health concerns while promoting positive change, reducing recidivism, and supporting successful rehabilitation and reintegration into the community.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4">Benefits</h3>
            <ul className="space-y-3 mb-8">
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-indigo-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Targeted behavioral interventions and mental health support</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-indigo-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Skills for making positive, pro-social choices</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-indigo-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Reduced risk of re-offending</span>
              </li>
              <li className="flex items-start">
                <span className="flex-shrink-0 w-6 h-6 bg-indigo-100 rounded-full flex items-center justify-center mr-3 mt-1">
                  <span className="text-indigo-600 text-sm">✓</span>
                </span>
                <span className="text-gray-700">Pathways to education, employment, and community belonging</span>
              </li>
            </ul>

            <button
              onClick={() => setShowAppointmentModal(true)}
              className="w-full md:w-auto bg-indigo-600 text-white px-8 py-4 rounded-lg hover:bg-indigo-700 transition-colors font-semibold text-lg"
            >
              Schedule Consultation
            </button>
          </div>
        </div>
      </div>

      <Footer />
      
      {showAppointmentModal && (
        <AppointmentModal 
          onClose={() => setShowAppointmentModal(false)}
          insuranceProviders={insuranceProviders}
        />
      )}
    </div>
  );
};

export default JuvenileJusticePage;